export default function HelpInfoIcon({
    style,
    fill="#83CFA4",
    width="26",
    height="26"
}){
    return <svg width="24" height="24" style={style} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.0005 11.796C22.0005 17.2061 17.5232 22 12.0004 22C6.4775 22 19.4614 18.5 19.0005 11.796C18.4912 4.38802 7.31095 2 12.8338 2C18.3566 2 22.0005 6.38587 22.0005 11.796Z" fill="#83CFA4"/>
    <ellipse cx="12" cy="11.7959" rx="10" ry="9.79592" stroke="#536987" strokeWidth="1.5"/>
    <path d="M12 17.5V12" stroke="#536987" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M14 8C14 6.89543 13.1075 6 12.0066 6H11.9934C10.8925 6 10 6.89543 10 8C10 9.10457 10.8925 10 11.9934 10H12.0066C13.1075 10 14 9.10457 14 8Z" fill="#536987"/>
    </svg>  
}